
      import CloseBold from './close-bold.vue'
      import type { App, Plugin } from 'vue'

      export const CloseBoldPlugin: Plugin = {
        install(app: App) {
          app.component('CloseBold', CloseBold)
        },
      }
      export { CloseBold }
      